module.exports = __webpack_public_path__ + "assets/img/tgsm4.d0d095c1.png";